import { render, staticRenderFns } from "./LandingPageFooter.vue?vue&type=template&id=ea01d2cc&scoped=true"
import script from "./LandingPageFooter.vue?vue&type=script&lang=js"
export * from "./LandingPageFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingPageFooter.vue?vue&type=style&index=0&id=ea01d2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea01d2cc",
  null
  
)

export default component.exports